import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../theme';

// todo: implement different predefined states ( info, error, suggestion etc.)
export interface Props {
	wrapperClassName?: string;
	className?: string;
	icon?: React.ReactElement | string;
}

const Disclaimer: React.FC<Props> = props => {
	const { DisclaimerStyles: theme } = useTheme('Disclaimer');

	return (
		<div className={cn(theme.disclaimer, props.wrapperClassName)}>
			<div className={cn(theme.disclaimer__inner, props.className)}>
				{props.icon ? (
					React.isValidElement(props.icon) ? (
						props.icon
					) : (
						<span className={theme.disclaimer__icon}>{props.icon}</span>
					)
				) : null}

				{props.children}
			</div>
		</div>
	);
};

export default Disclaimer;
